import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind.css';
import './styles/dashboard.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import { Auth0Provider } from "@auth0/auth0-react";

ReactDOM.render(
  // <Auth0Provider
  //   domain="featuredashboard.us.auth0.com"
  //   clientId="A6w3aCElOd8EewMR9wXmTNaZnNqzcT7y"
  //   redirectUri={window.location.origin + '/newVersion'}
  // >
  // {/* </Auth0Provider>, */}
    <App />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
